export default () => (
  /**
   * Icone de um "+".
   * Responsavel por adicionar coordenadas no mapa.
   * Encontrado na ferramenta de inserir coordenadas.
   */
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="7.26562" width="2.04444" height="16" rx="1.02222" fill="#BEC7DC" />
    <rect
      x="16.2871"
      y="6.97852"
      width="2.04189"
      height="16"
      rx="1.02095"
      transform="rotate(90 16.2871 6.97852)"
      fill="#BEC7DC"
    />
  </svg>
);
